import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import faultRepair from './modules/faultRepair'
import rota from './modules/rota'
import home from './modules/home'
import baoxiu from './modules/baoxiu'
import rllr from './modules/rllr'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    faultRepair,
    rota,
    home,
    baoxiu,
    rllr
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js